import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    transactionId: z.string(),
    fileId: z.string(),
    disposition: z.enum(["inline", "attachment"]).default("inline"),
  }),
  response: z.object({
    url: z.string(),
  }),
};
